// app/app.component.ts
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoadingIndicatorComponent } from './shared/components/loading-indicator/loading-indicator.component';
import { ToastComponent } from './shared/components/toast/toast.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { AuthService } from './core/services/auth.service';
import { UserProfileDialogComponent } from './shared/components/user/user-profile-dialog/user-profile-dialog.component';

@Component({
    selector: 'app-root',
    imports: [
        RouterOutlet,
        LoadingIndicatorComponent,
        ToastComponent,
        ConfirmDialogModule,
        UserProfileDialogComponent
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'apidef-website';

  constructor(
    authService: AuthService,
  ) {
    authService.initializePersistence();
  }
}
